<template>
   <node-view-wrapper class="kop">
      <span class="label" contenteditable="false">Vue Component</span>
      <node-view-content class="kop-content" />
      <button @click="doSomething()">Click</button>
      {{node.attrs.value}}
   </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from "@tiptap/vue-2";

export default {
   components: {
      NodeViewWrapper,
      NodeViewContent,
   },

   props: nodeViewProps,
   mounted() {
      console.log(this.node.content.content[0])
      //this.node.content.content[0].text = "jesse"
      
     // this.node.textContent = 'jesseeee'
   },
   data() {
      return {
         jesse: "ddd",
      };
   },
   methods: {
      doSomething() {
         console.log(this.node.textContent);
         //console.log(this.node.content.content[0].text);
      },
   },
   watch: {
      "node.textContent": {
         handler(newVal) {
            console.log("watcher")
            this.node.attrs.value = newVal;
         },
         immediate: true
      },
   },
};
</script>

<style lang="scss">
.kop {
   background-color: #fff;
   border: 1px solid #ddd;
   border-radius: 0.5rem;
   margin: 1rem 0;
   position: relative;
   width: 95%;
   max-width: 1200px;
}

.label {
   margin-left: 1rem;
   background-color: #0d0d0d;
   font-size: 0.6rem;
   letter-spacing: 1px;
   font-weight: bold;
   text-transform: uppercase;
   color: #fff;
   position: absolute;
   top: 0;
   padding: 0.25rem 0.75rem;
   border-radius: 0 0 0.5rem 0.5rem;
}

.kop-content {
   margin: 2.5rem 1rem 1rem;
   padding: 0.5rem;
   border: 2px dashed #0d0d0d20;
   border-radius: 0.5rem;
}
</style>
